module.exports = __webpack_public_path__ + "static/img/sino.9b80120.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu-home/sino.png
// module id = mSjh
// module chunks = 1